'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Zipcode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _validators = require('./validators');

var _nodeToolbox = require('@esnpm/node-toolbox');

var _Text2 = require('./Text');

var _inputs = require('./inputs');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _translate = require('@esnpm/translate');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Zipcode = exports.Zipcode = (_temp = _class = function (_Text) {
	_inherits(Zipcode, _Text);

	function Zipcode(props) {
		_classCallCheck(this, Zipcode);

		var _this = _possibleConstructorReturn(this, (Zipcode.__proto__ || Object.getPrototypeOf(Zipcode)).call(this, props));

		_this.zipcodeValidator = _this.props.validators[0];

		// this.zipcodeValidator = new ESValidator.ZipCodePattern("DE");
		return _this;
	}

	_createClass(Zipcode, [{
		key: 'setFormFocus',
		value: function setFormFocus() {
			// überschreibt die Funktion aus dem Field.js
			// setstate wird aufgerufen, um ein re-rendern zu erzwingen,
			// Hint wird dadurch angezeigt, nachdem zb das land gewechselt wurde,   und anschliessend das zipcode feld wieder den focus erhält
			this.context.esForm.setFocus(this.props.fieldName);
			this.setState({});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			_get(Zipcode.prototype.__proto__ || Object.getPrototypeOf(Zipcode.prototype), 'componentWillMount', this).call(this);
			this.registerValidator(this.zipcodeValidator);
		}
	}, {
		key: 'setCountryCode',
		value: function setCountryCode(cc) {
			this.zipcodeValidator.setPatternByCountryCode(cc);
			this.handleOnChange(this.state.value);
		}
	}, {
		key: 'getCountryPattern',
		value: function getCountryPattern() {
			var cc = this.props.validators[0].cc;
			var ret = null;
			switch (cc) {
				case "AD":
					ret = "AD999";
					break;
				case "AR":
					ret = "A9999AAA";
					break;
				case "AX":
					ret = "FI99999";
					break;
				case "AZ":
					ret = "AZ9999";
					break;
				case "BB":
					ret = "BB99999";
					break;
				case "BH":
					ret = "999 or 9999";
					break;
				case "BM":
					ret = "AA99";
					break;
				case "BN":
					ret = "AA9999";
					break;
				case "CA":
					ret = "A9A9A9 or A9A 9A9";
					break;
				case "CP":
					ret = "CP99999";
					break;
				case "EC":
					ret = "A9999A or a9999a";
					break;
				case "FI":
					ret = "FI99999";
					break;
				case "FO":
					ret = "FO999";
					break;
				case "GB":
					ret = "A00AA or A000AA or A0A0AA or AA00AA or AA000AA or AA0A0AA";
					break;
				case "GF":
					ret = "97399 or 98399";
					break;
				case "GG":
					ret = "A00AA or A000AA or A0A0AA or AA00AA or AA000AA or AA0A0AA";
					break;
				case "GP":
					ret = "97999 or 98999";
					break;

				case "GU":
					ret = "9699";
					break;
				case "HN":
					ret = "AA9999";
					break;
				case "HR":
					ret = "HR99999";
					break;
				case "HT":
					ret = "HT9999";
					break;
				case "IM":
					ret = "A00AA or A000AA or A0A0AA or AA00AA or AA000AA or AA0A0AA";
					break;
				case "JE":
					ret = "A00AA or A000AA or A0A0AA or AA00AA or AA000AA or AA0A0AA";
					break;
				case "KR":
					ret = "SEOUL123456";
					break;
				case "LB":
					ret = "1234 or 12341234";
					break;
				case "LT":
					ret = "LT99999";
					break;
				case "LV":
					ret = "LV9999";
					break;
				case "MD":
					ret = "MD9999";
					break;
				case "MT":
					ret = "AAA12 or AAA123";
					break;
				case "NL":
					ret = "1234AA";
					break;
				case "PF":
					ret = "97799 or 98799";
					break;
				case "PM":
					ret = "97500";
					break;
				case "PW":
					ret = "96940";
					break;
				case "RE":
					ret = "99999";
					break;
				case "SE":
					ret = "SE12345";
					break;
				case "SH":
					ret = "STHL1ZZ";
					break;
				case "SI":
					ret = "SI1234";
					break;
				case "SM":
					ret = "47891";
					break;
				case "SO":
					ret = "AA12345";
					break;
				case "SO":
					ret = "CP1234";
					break;
				case "SZ":
					ret = "A1234";
					break;
				case "TC":
					ret = "TKCA 1ZZ";
					break;
				case "US":
					ret = "12345-1234";
					break;
				case "VI":
					ret = "12345-1234";
					break;
				case "WF":
					ret = "98612";
					break;
				default:
					break;
			}
			if (ret === null) {
				return this.props.validators[0].reg.toString();
			}
			return ret;
		}
	}, {
		key: 'getCountrySpecificHint',
		value: function getCountrySpecificHint() {
			var regex = this.props.validators[0].reg;

			var path = "esforms.zipCodeCountryHints.";

			switch (regex.toString()) {
				case "/^(\\d{3})$/":
					return _react2.default.createElement(_translate.Tr, { path: path + "DigitsOnly", format: { "AMOUNT": 3 } });
					break;

				case "/^(\\d{4})$/":
					return _react2.default.createElement(_translate.Tr, { path: path + "DigitsOnly", format: { "AMOUNT": 4 } });
					break;

				case "/^(\\d{5})$/":
					return _react2.default.createElement(_translate.Tr, { path: path + "DigitsOnly", format: { "AMOUNT": 5 } });
					break;

				case "^(\\d{6})$":
					return _react2.default.createElement(_translate.Tr, { path: path + "DigitsOnly", format: { "AMOUNT": 6 } });
					break;

				case "^(\\d{7})$":
					return _react2.default.createElement(_translate.Tr, { path: path + "DigitsOnly", format: { "AMOUNT": 7 } });
					break;

				case "^(\\d{8})$":
					return _react2.default.createElement(_translate.Tr, { path: path + "DigitsOnly", format: { "AMOUNT": 8 } });
					break;

				case "^(\\d{10})$":
					return _react2.default.createElement(_translate.Tr, { path: path + "DigitsOnly", format: { "AMOUNT": 10 } });
					break;
				default:
					var pattern = this.getCountryPattern();
					return pattern;

					break;
			}

			return null;
		}
	}, {
		key: 'renderHint',
		value: function renderHint() {
			if (this.props.noHint) return null;
			if (this.state.valid) return null;
			if (this.context.esForm.state.focus != this.props.fieldName) return null;

			if (this.isEmpty()) return null;

			var country_code = this.props.validators[0].cc;

			var country_hint = this.getCountrySpecificHint();

			var validClasses = {};
			var validChange = this.props.noValidationClassChange || this.context.esForm.props.noValidationClassChange;

			if (!validChange) {
				var _classNames;

				var classValid = this.props.classValid != null ? this.props.classValid : this.context.esForm.props.classValid;
				var classInValid = this.props.classInValid != null ? this.props.classInValid : this.context.esForm.props.classInValid;

				validClasses = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, classValid, this.state.valid), _defineProperty(_classNames, classInValid, !this.state.valid), _classNames));
			}
			// const classes = classNames("alert", validClasses);
			var classes = (0, _classnames2.default)(this.context.esForm.props.classHint);

			return _react2.default.createElement(
				'div',
				{ className: 'ESFieldHint' },
				_react2.default.createElement(
					'div',
					{ className: classes },
					_react2.default.createElement(_translate.Tr, { path: "esforms.zipCodeCountryHints.ChosenCountry" }),
					'\xA0',
					_react2.default.createElement(_translate.Tr, { path: "esforms.zipCodeCountryHints.Pattern" }),
					'\xA0',
					_react2.default.createElement(
						'strong',
						null,
						country_hint
					)
				)
			);
		}
	}, {
		key: 'renderInput',
		value: function renderInput(props) {
			return _react2.default.createElement(_inputs.ESInput.Text, props);
		}
	}]);

	return Zipcode;
}(_Text2.Text), _class.defaultProps = Object.assign({}, _Text2.Text.defaultProps, {
	fieldName: 'ZIPCODE',
	label: _react2.default.createElement(_translate.Tr, { path: 'esforms.fields.ZIPCODE.label' }),
	trPlaceHolder: "esforms.fields.ZIPCODE.placeHolder",
	trHint: "esforms.fields.ZIPCODE.hint",
	allowedCharacters: "[A-Za-z0-9 -]",
	onRef: function onRef(r) {}
}), _class.propTypes = Object.assign({}, _Text2.Text.propTypes, {}), _temp);